/**
 * HTTP layer for virtual site sharing. Third-party shared-site access:
 * memberships, auto-share rules, relocation of shared sites, and share/unshare
 * actions.
 *
 * Contains:
 * - fetchVirtualMemberships: third-party membership reads
 * - fetchAutoShares / postAutoShares / deleteAutoShares: auto-share rules
 * - fetchRelocationDestinations / postRelocateThirdPartySharedSite: relocate a shared site
 * - postShareVirtualAccess / postUnshareVirtualAccess: share/unshare actions
 */
// Virtual API

import apiClient from '../http-common';
import { generateQueryParams } from '../utils';

const VIRTUAL_ENDPOINT = '/virtual';

export const fetchVirtualMemberships = queryParams =>
  apiClient.get(`${VIRTUAL_ENDPOINT}/memberships/`, { params: generateQueryParams(queryParams) }).then(res => res.data);

export const fetchAutoShares = queryParams =>
  apiClient.get(`${VIRTUAL_ENDPOINT}/autoshares/`, { params: generateQueryParams(queryParams) }).then(res => res.data);

export const fetchRelocationDestinations = (siteGroupId, siteId) =>
  apiClient
    .get(`${VIRTUAL_ENDPOINT}/available-destinations/`, {
      params: { site_group_id: siteGroupId, site_id: siteId },
    })
    .then(res => res.data);

export const postRelocateThirdPartySharedSite = data =>
  apiClient.post(`${VIRTUAL_ENDPOINT}/relocate/`, data).then(res => res.data);

export const postAutoShares = data => apiClient.post(`${VIRTUAL_ENDPOINT}/autoshares/`, data).then(res => res.data);

export const deleteAutoShares = ids =>
  apiClient.delete(`${VIRTUAL_ENDPOINT}/autoshares/`, { data: ids }).then(res => res.data);

export const postShareVirtualAccess = data => apiClient.post(`${VIRTUAL_ENDPOINT}/share/`, data).then(res => res.data);

export const postUnshareVirtualAccess = data =>
  apiClient.post(`${VIRTUAL_ENDPOINT}/unshare/`, data).then(res => res.data);
